module.exports = __webpack_public_path__ + "static/img/133.86b0193.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/133.png
// module id = vXvj
// module chunks = 0